/**
 * DataLayer - buttonClick event
 * @description по нажатию на любую кнопку срабатывает событие "buttonClick"
 * @description Отличается от обычного DLClickEvent тем, что свойство name имеет тип string
 *
 * @example DLClickEventExtended({ name: "любая строка", eventAction: "любая строка", placement: 'header', eventLabel?: globalThis?.location?.href})
 *
 * @default event: "buttonClick"
 * @default eventCategory: "click_block"
 * @default eventAction: ""
 * @default eventLabel: Страница на которой произошло событие
 *
 */

import { pushToDL } from "../utils/helper"
import type { TDLPageURL } from "./type"

export type TDLPlacement =
  | "header"
  | "banner"
  | "switcher_content"
  | "faq"
  | "calculator"
  | "promo"
  | "main"
  | "benefits"
  | "burger_menu"
  | "features"
  | "debit_card_installments"
  | "partners"

export type TDLCategory =
  | "click_block"
  | "click_cta"
  | "monthly_spending_calc"
  | "click_tooltip"
  | "loan_term_selection"

export const DLClickEventExtended = ({
  name,
  eventCategory = "click_block",
  eventAction = "",
  placement,
  eventLabel = globalThis?.location?.href,
}: {
  name: string
  eventCategory?: TDLCategory
  eventAction?: string
  placement: TDLPlacement
  eventLabel?: TDLPageURL
}) => {
  pushToDL({ event: "buttonClick", name, eventCategory, eventAction, placement, eventLabel })
}
